// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
export type BiddersTab_BidderFragment = { __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidContract?: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined, request?: { __typename?: 'BidPackageRequest', id: string, sentDate?: Types.Scalars['Date']['input'] | null | undefined, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined, primaryContact?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string } | null | undefined, secondaryContact?: { __typename?: 'TradePartnerContact', email?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string } | null | undefined } | null | undefined };

export type BiddersTab_TradePartnerContactFragment = { __typename?: 'TradePartnerContact', email?: string | null | undefined, mobilePhone?: string | null | undefined, id: string, name: string };

export const BiddersTab_TradePartnerContactFragmentDoc = gql`
    fragment BiddersTab_TradePartnerContact on TradePartnerContact {
  ...Named
  email
  mobilePhone
}
    ${NamedFragmentDoc}`;
export const BiddersTab_BidderFragmentDoc = gql`
    fragment BiddersTab_Bidder on BidPackageBidder {
  id
  name
  kind
  archivedAt
  tradePartner {
    ...Named
  }
  bidContract {
    id
    archivedAt
    internalEstimateType {
      code
    }
  }
  request {
    id
    sentDate
    archivedAt
    primaryContact {
      ...BiddersTab_TradePartnerContact
    }
    secondaryContact {
      ...BiddersTab_TradePartnerContact
    }
  }
}
    ${NamedFragmentDoc}
${BiddersTab_TradePartnerContactFragmentDoc}`;